<div class="project--filter position-relative" id="treeTabContainer">
  <fieldset class="btn-group btn-group-toggle switch-view d-inline-block" role="group">
    <legend class="sr-only">Switch between {{showTableTab ? 'table' : ''}},
      {{(viewLocation !== 'frontFacingTaxonomyDetail' && viewLocation !== 'taxonomydetail') ? 'tree' : ''}} and
      Details view</legend>

    <button
        id="{{tab}}View"
        class="btn btn-common btn-sm top top-right position-relative"
        [ngClass]="{'tooltip':showTooltip, 'active':currentTreeTab === tab}"
        [attr.aria-label]="tab==='detailview'?'Detail view':(tab==='tableview')?'Table view':tab"
        [attr.data-tooltip]="showTooltip?( (tab.slice(0, -4)| titlecase) + ' View') : null"
        *ngFor="let tab of treeTabItems; let $index=index"
        (click)="onTreeTabSelected(tab,$event)"
        [attr.aria-pressed]="currentTreeTab === tab">
      <ng-container *ngIf="!showTooltip">
        {{exactTextNeeded ? tab : (tab.slice(0, -4)| titlecase)}} {{exactTextNeeded ? '' : ' View'}}
      </ng-container>
      <span class="material-icons-outlined button-icon font-4x" aria-hidden="true">
      <ng-container *ngIf="tab==='tableview'">grid_view</ng-container>
      <ng-container *ngIf="tab==='detailview'">view_list</ng-container>
      <ng-container *ngIf="tab==='customview'">segment</ng-container>
      <ng-container *ngIf="tab==='listview'">list_alt</ng-container>
      </span>
    </button>
  </fieldset>
</div>
